<template>
  <v-tooltip
    class="help-icon"
    top
    v-bind:bottom="bottom"
    v-bind:max-width="maxWidth"
  >
    <template v-slot:activator="{ on, attrs }">
      <img
        v-if="typeIcon === 'info'"
        alt="Помощь"
        class="help-icon help-icon--info"
        src="@/assets/img/help.svg"
        v-bind="attrs"
        v-on="on"
      />
      <img
        v-else-if="typeIcon === 'question'"
        class="help-icon help-icon--question"
        src="@/assets/img/question-mark.svg"
        width="24"
        height="24"
        alt="Помощь"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    bottom: { default: false, type: Boolean },
    maxWidth: { type: Number, default: 490 },
    tooltipText: { type: String, default: '' },
    typeIcon: { type: String, default: 'info' },
  },
};
</script>

<style scoped lang="scss">
.help-icon {
  display: inline-block;
  margin: 5px;
  align-self: flex-start;
  object-fit: contain;
  &--question {
    margin: 0;
  }
  span {
    text-align: center;
  }
}
</style>
